import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import style from "./PortfolioModal.scss";
import toggleIcon from "../../../../public/svg/x-symbol-svgrepo-com.svg";
import { showToast } from "../../../utils/helper";
import "react-toastify/dist/ReactToastify.css";
import { getOriginalBodyPadding } from "reactstrap/lib/utils";
import { Tooltip } from "../../Tooltip/Tooltip";
import { askPrice } from "../../../services/api/inout";
import { getCurrentAccount, getTexts } from "../../../reducers/selectors";
import { useSelector } from "react-redux";

const PortfolioModal = ({ modal, toggle, asset }) => {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const currentAccount = useSelector(getCurrentAccount);
  const texts = useSelector(getTexts);

  const onConfirm = () => {
    if (+value > +asset.nominalValueAvailable)
      showToast("La cantidad ingresada no puede ser mayor a la cantidad del portafolio.", true);
    else {
      setLoading(() => true);
      const Order = {
        AssetId: asset.id,
        OrderHierarchy: "Parent",
        CurrentAccount: {
          AccountId: currentAccount.id,
          Quantity: value,
        },
      };
      askPrice({ Order })
        .then(({ response }) => {
          if (response.result.Code !== 200) showToast("Error solicitando precio", true);
          else {
            showToast("Precio solicitado correctamente");
            toggle();
          }
        })
        .catch((err) => console.error(err))
        .finally(() => {
          setLoading(() => false);
        });
    }
  };

  const handleChange = (event) => {
    const result = event.target.value.replace(/\D/g, "");
    setValue(result);
  };

  return (
    <Modal size="sm" isOpen={modal} contentClassName={style.content}>
      <div className={style.modalWrapper}>
        <ModalBody className={style.body}>
          <div className={style.header}>
            <span>Inicio proceso de venta:</span>
            <img className={style.toggleIcon} src={toggleIcon} alt="X" onClick={toggle} />
          </div>
          <span className={style.name}>{asset.name}</span>
          <br></br>
          <span className={style.amount}>
            <p>cantidad:</p>
            <input type="text" value={value} onChange={handleChange} />
          </span>
        </ModalBody>
        {currentAccount.id && (
          <ModalFooter className={style.footer}>
            <Button className={style.button} onClick={onConfirm} disabled={loading}>
              solicitar precio
            </Button>
          </ModalFooter>
        )}
      </div>
      <Tooltip
        text={texts.tooltips.sell_quote}
        height="30px"
        width="30px"
        top="100px"
        right="-40px"
        backgroundColor="white"
        borderRadius="50%"
      />
    </Modal>
  );
};

export default PortfolioModal;
